import React, { PureComponent } from "react";
import CheckboxComponent from "@material-ui/core/Checkbox";
import styled, { withTheme } from "styled-components";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { IndeterminateCheckBox } from "@material-ui/icons";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PropTypes from "prop-types";
import themes from "../theme";

const style = createMuiTheme({
  palette: {
    primary: {
      main: themes.palette.PRIMARY
    }
  },
  typography: {
    useNextVariants: true
  }
});

class CheckboxGroupComp extends PureComponent {
  state = {
    checkboxValue: null
  };

  onChangeCheckbox = value => {
    const { onChange } = this.props;
    this.setState({ checkboxValue: value }, () => {
      const { checkboxValue } = this.state;
      onChange(checkboxValue);
    });
  };

  render() {
    const { color, sectionTitle, options, disabled } = this.props;
    return (
      <MuiThemeProvider theme={style}>
        <h2>{sectionTitle}</h2>
        {options.map(({ label, value }) => (
          <FormControlLabel
            key={value}
            control={
              <CheckboxComponent // eslint-disable-line react/jsx-wrap-multilines
                color={color}
                icon={<CheckBoxOutlineBlankIcon fontSize="default" />}
                checkedIcon={<CheckBoxIcon fontSize="default" />}
                indeterminateIcon={
                  <IndeterminateCheckBox // eslint-disable-line react/jsx-wrap-multilines
                    color="colorPrimary"
                    fontSize="default"
                  />
                }
                value={value}
              />
            }
            label={label}
            onChange={() => this.onChangeCheckbox(value)}
            disabled={disabled}
          />
        ))}
      </MuiThemeProvider>
    );
  }
}

CheckboxGroupComp.propTypes = {
  theme: PropTypes.shape({}),
  sectionTitle: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  color: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

CheckboxGroupComp.defaultProps = {
  theme: {},
  sectionTitle: "",
  options: [],
  color: "",
  onChange: () => {},
  disabled: false
};

export const CheckboxGroup = styled(withTheme(CheckboxGroupComp))``;
